import { c as _c } from "react/compiler-runtime";
import React from 'react';
import BVReviews from 'components/consumer/PDP/BazaarVoice/BVReviews';
import usePdpFullVariantSku from '../state/pdpFullVariantSku/usePdpFullVariantSku';
const BVPDPCustomerPhotosUI = () => {
  const $ = _c(2);
  const variantSku = usePdpFullVariantSku();
  let t0;
  if ($[0] !== variantSku) {
    t0 = <div className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14" id="PDPCustomerPhotos"><BVReviews productId={variantSku} /></div>;
    $[0] = variantSku;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default BVPDPCustomerPhotosUI;